import { useCallback } from 'react'

import type { CallLogFiltersInput } from 'types/graphql'

import { useQuery } from '@redwoodjs/web'

import { toast } from 'src/components/Overlays/Toast/Toast'
import { GET_VOICE_AGENT_CALL_HEATMAP } from 'src/graphql/callAnaltyics.graphql'
import { useRefetchOnKeyChange } from 'src/pages/AnalyticsPage/components/trendChartHelpers'

import { CallCoverageHeatmapView } from './CallCoverageHeatmapView'
import type { HeatmapCell, HeatmapSummary } from './constants'

export { CALL_COVERAGE_INFO_TEXT } from './constants'

export interface CallCoverageHeatmapProps {
  filters: CallLogFiltersInput
  /**
   * Bumped by the page-level Refresh button — the Overview tab keeps its
   * state across refreshes and expects self-fetching children to refetch
   * when this changes (same contract as CallVolumeContainer).
   */
  refreshKey: number
}

const CallCoverageHeatmap = ({
  filters,
  refreshKey,
}: CallCoverageHeatmapProps) => {
  const onError = useCallback(() => {
    toast('Something went wrong, please try again.', 'error')
  }, [])

  const { data, loading, refetch } = useQuery(GET_VOICE_AGENT_CALL_HEATMAP, {
    variables: { filters },
    onError,
    notifyOnNetworkStatusChange: true,
  })

  useRefetchOnKeyChange(refetch, refreshKey)

  const heatmap = data?.voiceAgentCallHeatmap

  return (
    <CallCoverageHeatmapView
      timezone={heatmap?.timezone ?? 'America/New_York'}
      cells={(heatmap?.cells ?? []) as HeatmapCell[]}
      summary={(heatmap?.summary ?? null) as HeatmapSummary | null}
      loading={loading}
    />
  )
}

export default CallCoverageHeatmap
